import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';

const references = [
  {
    name: "Walt Disney Imagineering",
    url: "https://sites.disney.com/waltdisneyimagineering/"
  },
  {
    name: "Universal Creative",
    url: "https://corporate.universaldestinationsandexperiences.com/universal-creative/"
  },
  {
    name: "Garner Holt Productions",
    url: "https://www.garnerholt.com/"
  },
  {
    name: "Sally Dark Rides",
    url: "https://sallydarkrides.com/"
  },
  {
    name: "Animax Designs",
    url: "https://www.animaxdesigns.com/"
  },
  {
    name: "Creature Technology Co.",
    url: "https://www.creaturetechnology.com/"
  },
  {
    name: "LF Studios",
    url: "https://lfstudios.com//"
  },
  {
    name: "Themed Entertainment Association",
    url: "https://www.teaconnect.org/"
  },
  {
    name: "Catalyst Engineering",
    url: "https://catalystrobots.com/"
  },
  {
    name: "Roush Entertainment Systems",
    url: "https://www.roush.com/industries/entertainment/"
  },
  {
    name: "Inside the Magic",
    url: "https://insidethemagic.net/"
  },
  {
    name: "Stan Winston - The History of Animatronics",
    url: "https://www.stanwinstonschool.com/blog/animatronics-world-review"
  },
  {
    name: "Disney Wiki - Audio-Animatronics",
    url: "https://disney.fandom.com/wiki/Audio-Animatronics"
  },
  {
    name: "Tait Towers",
    url: "https://www.taittowers.com/"
  }
];

const References = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold mb-6">References</h2>
        <div className="card bg-background-secondary p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {references.map((ref) => (
              <a
                key={ref.name}
                href={ref.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-content-secondary hover:text-brand transition-colors"
              >
                <span>{ref.name}</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default References;